<template>
  <div id="hubspot-form"></div>
</template>

<script>
export default {
  name: 'HubspotStatsheetRejectionForm',
  mounted() {
    // Load the external script
    const script = document.createElement('script');
    script.src = '//js.hsforms.net/forms/embed/v2.js';
    script.charset = 'utf-8';
    script.onload = () => {
      if (window.hbspt) {
        window.hbspt.forms.create({
          portalId: "20710591",
          formId: "f0d5f16e-55e3-48b1-9455-e4d925671cfe",
          region: "na1",
          target: "#hubspot-form"
        });
      }
    };
    document.body.appendChild(script);
  }
};
</script>